import { lazy as t } from "react";
const o = {
  AD: t(() => import("../../AD-Dh0y6EXd.js")),
  AE: t(() => import("../../AE-C_r6FHLQ.js")),
  AF: t(() => import("../../AF-CarziHKf.js")),
  AG: t(() => import("../../AG-CA0qZi5A.js")),
  AI: t(() => import("../../AI-DOp0fKy3.js")),
  AL: t(() => import("../../AL-DZxExDCF.js")),
  AM: t(() => import("../../AM-Cq04QDKU.js")),
  AO: t(() => import("../../AO-B3SLaNbj.js")),
  AR: t(() => import("../../AR-D_C8MZWb.js")),
  AS: t(() => import("../../AS-CvWlbU2Q.js")),
  AT: t(() => import("../../AT-D7JppSww.js")),
  AU: t(() => import("../../AU-_qiU5DLr.js")),
  AW: t(() => import("../../AW-jIvLyVre.js")),
  AX: t(() => import("../../AX-BD-faqxA.js")),
  AZ: t(() => import("../../AZ-DAY4LcQk.js")),
  BA: t(() => import("../../BA-Ddd77-DV.js")),
  BB: t(() => import("../../BB-C6vXsoPc.js")),
  BD: t(() => import("../../BD-CuOOv3uU.js")),
  BE: t(() => import("../../BE-CSrLN0T9.js")),
  BF: t(() => import("../../BF-Bk0C1jnJ.js")),
  BG: t(() => import("../../BG-BmN6axsw.js")),
  BH: t(() => import("../../BH-CFiWr_dr.js")),
  BI: t(() => import("../../BI-BVk65rIq.js")),
  BJ: t(() => import("../../BJ-CtWeKk6l.js")),
  BL: t(() => import("../../BL-DsCOLCyv.js")),
  BM: t(() => import("../../BM-Uat5jGT1.js")),
  BN: t(() => import("../../BN-CY1EmWAF.js")),
  BO: t(() => import("../../BO-DW7P4GFl.js")),
  BQ: t(() => import("../../BQ-q_-e3wPj.js")),
  "BQ-1": t(() => import("../../BQ-1-zejm6md4.js")),
  "BQ-2": t(() => import("../../BQ-2-m1VTn8rW.js")),
  BR: t(() => import("../../BR-kEAMMsp9.js")),
  BS: t(() => import("../../BS-khFdIgx_.js")),
  BT: t(() => import("../../BT-DUFcuv7k.js")),
  BW: t(() => import("../../BW-CXTqPyAj.js")),
  BY: t(() => import("../../BY-CZric7Rj.js")),
  BZ: t(() => import("../../BZ-D8vyIrPE.js")),
  CA: t(() => import("../../CA-9KXDnWrr.js")),
  CC: t(() => import("../../CC-DJVhHCZ9.js")),
  CD: t(() => import("../../CD-QVTWgI7n.js")),
  "CD-1": t(() => import("../../CD-1-5lvNWYMA.js")),
  CF: t(() => import("../../CF-Noc6rKHR.js")),
  CH: t(() => import("../../CH-CCyJpWi0.js")),
  CK: t(() => import("../../CK-DiYD_Jts.js")),
  CL: t(() => import("../../CL-CHm3ST9s.js")),
  CM: t(() => import("../../CM-ijWSGk7a.js")),
  CN: t(() => import("../../CN-QKftIE7o.js")),
  CO: t(() => import("../../CO-BJfZ7nUF.js")),
  CR: t(() => import("../../CR-BhjVEMRH.js")),
  CU: t(() => import("../../CU-C_n6I-Xr.js")),
  CW: t(() => import("../../CW-CBV0XEgU.js")),
  CX: t(() => import("../../CX-CDYe88k5.js")),
  CY: t(() => import("../../CY-DG0vGwuD.js")),
  CZ: t(() => import("../../CZ-WaOGcU_1.js")),
  DE: t(() => import("../../DE-BWoH50VE.js")),
  DJ: t(() => import("../../DJ-DPH3xxLR.js")),
  DK: t(() => import("../../DK-DRpXlA1b.js")),
  DM: t(() => import("../../DM-DxBHlOQM.js")),
  DO: t(() => import("../../DO-mUFfy1J0.js")),
  DS: t(() => import("../../DS-DFWIvlBg.js")),
  DZ: t(() => import("../../DZ-BxUR3rpx.js")),
  earth: t(() => import("../../earth-CyIsyZcQ.js")),
  EC: t(() => import("../../EC-kSFKQ4t_.js")),
  EE: t(() => import("../../EE-FM2Le1_s.js")),
  EG: t(() => import("../../EG-D6oa4xUC.js")),
  EH: t(() => import("../../EH-D3M-et0S.js")),
  ER: t(() => import("../../ER-BRBH20Hw.js")),
  ES: t(() => import("../../ES-BoMqSYKY.js")),
  ET: t(() => import("../../ET-Dc7quq7-.js")),
  FI: t(() => import("../../FI-DbNLxBqJ.js")),
  FJ: t(() => import("../../FJ-Ca1s3IHf.js")),
  FK: t(() => import("../../FK-vGqAw1r3.js")),
  FM: t(() => import("../../FM-gZLsJYpj.js")),
  FO: t(() => import("../../FO-C2IpAdLH.js")),
  FR: t(() => import("../../FR-CNVMMOMJ.js")),
  GA: t(() => import("../../GA-DZAC6cMR.js")),
  GB: t(() => import("../../GB-Dgi7pmoZ.js")),
  "GB-2": t(() => import("../../GB-2-Dw6N8P16.js")),
  GD: t(() => import("../../GD-BLB3RIAc.js")),
  GE: t(() => import("../../GE-CgP_9S6y.js")),
  GG: t(() => import("../../GG-CNzZm4XF.js")),
  GH: t(() => import("../../GH-CQq-9xm0.js")),
  GI: t(() => import("../../GI-Bp2-ENYd.js")),
  GL: t(() => import("../../GL-BZIQH6Ow.js")),
  GM: t(() => import("../../GH-CQq-9xm0.js")),
  GN: t(() => import("../../GN-BGxPv8Xj.js")),
  GQ: t(() => import("../../GQ-CKIBQGBX.js")),
  GR: t(() => import("../../GR-Gf_Fdtps.js")),
  GT: t(() => import("../../GT-Cg3n8xhn.js")),
  GU: t(() => import("../../GU-TnCPpnLu.js")),
  GW: t(() => import("../../GW-CPVggzzM.js")),
  GY: t(() => import("../../GY-C0uIJWcE.js")),
  HK: t(() => import("../../HK-w0CB3Inb.js")),
  HN: t(() => import("../../HN-B5bV6Fz0.js")),
  HR: t(() => import("../../HR-CGjK-4Rf.js")),
  HT: t(() => import("../../HT-CBnVQW4e.js")),
  HU: t(() => import("../../HU-B9OFi08Z.js")),
  ID: t(() => import("../../ID-DGRxncSb.js")),
  IE: t(() => import("../../IE-C8DdJ5I-.js")),
  IL: t(() => import("../../IL-D9WXWG1X.js")),
  IM: t(() => import("../../IM-BtAwr9kq.js")),
  IN: t(() => import("../../IN-Ddr6gKNF.js")),
  IO: t(() => import("../../IO-kNo9o4w-.js")),
  IQ: t(() => import("../../IQ-Dj8SPUD2.js")),
  IR: t(() => import("../../IR-C0dXYGxs.js")),
  IS: t(() => import("../../IS-CQJHf85O.js")),
  IT: t(() => import("../../IT-C7OVkohx.js")),
  JE: t(() => import("../../JE-Cxq3-s2Y.js")),
  JM: t(() => import("../../JM-BhbsC7rp.js")),
  JO: t(() => import("../../JO-pq6Kbn9Z.js")),
  JP: t(() => import("../../JP-D0nJGG5C.js")),
  KE: t(() => import("../../KE-BqG8_Ott.js")),
  KG: t(() => import("../../KG-DKCtlQbu.js")),
  KH: t(() => import("../../KH-ZH4RbjyR.js")),
  KI: t(() => import("../../KI-CvwkECAG.js")),
  KM: t(() => import("../../KM-BvIxmubQ.js")),
  KN: t(() => import("../../KN-z_iw-EVG.js")),
  KP: t(() => import("../../KP-Dp_axeqL.js")),
  KR: t(() => import("../../KR-BYDgkrzE.js")),
  KW: t(() => import("../../KW-pO46l1oR.js")),
  KY: t(() => import("../../KY-CnPLRX7M.js")),
  KZ: t(() => import("../../KZ-DPYtp73C.js")),
  LA: t(() => import("../../LA-BFtw538Z.js")),
  LB: t(() => import("../../LB-DQ7uxPBF.js")),
  LC: t(() => import("../../LC-DQ5GWKvB.js")),
  LI: t(() => import("../../LI-BLE5QnIa.js")),
  LK: t(() => import("../../LK-k_gzEgG9.js")),
  LR: t(() => import("../../LR-0K1Z50If.js")),
  LS: t(() => import("../../LS-DWzo1in0.js")),
  LT: t(() => import("../../LT-BcGP9q9X.js")),
  LU: t(() => import("../../LU-CBgbiBLT.js")),
  LV: t(() => import("../../LV-D-WCK0K7.js")),
  LY: t(() => import("../../LY-DeK4Su2p.js")),
  MA: t(() => import("../../MA-EnqWD_pH.js")),
  MC: t(() => import("../../MC-X_4kJ379.js")),
  MD: t(() => import("../../MD-MT8dVBhB.js")),
  ME: t(() => import("../../ME-DtaXI4QJ.js")),
  MG: t(() => import("../../MG-DD1TQ3VS.js")),
  MH: t(() => import("../../MH-B6KAgAuO.js")),
  MK: t(() => import("../../MK-B2sAKHtb.js")),
  ML: t(() => import("../../ML-3-Crl74u.js")),
  MM: t(() => import("../../MM-v1bHuyQt.js")),
  MN: t(() => import("../../MN-CZaya1LQ.js")),
  MO: t(() => import("../../MO-BBxdVoeu.js")),
  MP: t(() => import("../../MP-ClcTJttd.js")),
  MQ: t(() => import("../../MQ-7os2szqQ.js")),
  MR: t(() => import("../../MR-Chw6S_Ad.js")),
  MS: t(() => import("../../MS-BYik1bXv.js")),
  MT: t(() => import("../../MT-BqIQpzih.js")),
  MU: t(() => import("../../MU-DXXHn73V.js")),
  MV: t(() => import("../../MV-9LkgNkAu.js")),
  MW: t(() => import("../../MW-Cr5nzUlW.js")),
  MX: t(() => import("../../MX-WtidAPmH.js")),
  MY: t(() => import("../../MY-Cz9aWwHe.js")),
  MZ: t(() => import("../../MZ-DpKD_RPm.js")),
  NA: t(() => import("../../NA-Bmtt7EsD.js")),
  NE: t(() => import("../../NE-Cw9aoBii.js")),
  NF: t(() => import("../../NF-De3oHQSQ.js")),
  NG: t(() => import("../../NG-BWVMH5OE.js")),
  NI: t(() => import("../../NI-CDNQZzeP.js")),
  NL: t(() => import("../../NL-C7aMN6G5.js")),
  NO: t(() => import("../../NO-ctICCK89.js")),
  NP: t(() => import("../../NP-CHHOgO64.js")),
  NR: t(() => import("../../NR-C4WopO_5.js")),
  NU: t(() => import("../../NU-BLRSCg7h.js")),
  NZ: t(() => import("../../NZ-DsVoBfyI.js")),
  OM: t(() => import("../../OM-B-CB2OPJ.js")),
  PA: t(() => import("../../PA-bxOKbD4g.js")),
  PE: t(() => import("../../PE-CZc4wFRM.js")),
  PF: t(() => import("../../PF-CoRlx3_X.js")),
  PG: t(() => import("../../PG-CSfYznoh.js")),
  PH: t(() => import("../../PH-CqXzDWKp.js")),
  PK: t(() => import("../../PK-wPA_rBDD.js")),
  PL: t(() => import("../../PL-CkL3uC6D.js")),
  PN: t(() => import("../../PN-BqVJJO99.js")),
  PR: t(() => import("../../PR-DokqwKrZ.js")),
  PS: t(() => import("../../PS-D22i1QeK.js")),
  PT: t(() => import("../../PT-B5gn8LXU.js")),
  PW: t(() => import("../../PW-w1zFBFOh.js")),
  PY: t(() => import("../../PY-C9gHao7z.js")),
  QA: t(() => import("../../QA-DFy09-YU.js")),
  RO: t(() => import("../../RO-CDr8uz7g.js")),
  RS: t(() => import("../../RS-DemJ14jr.js")),
  RU: t(() => import("../../RU-cTiA4Glg.js")),
  RW: t(() => import("../../RW-F2oRcZnz.js")),
  SA: t(() => import("../../SA-Dain-h85.js")),
  SB: t(() => import("../../SB-1teL10LM.js")),
  SC: t(() => import("../../SC-Dl_2CSGv.js")),
  SE: t(() => import("../../SE-BLcVH-nD.js")),
  SG: t(() => import("../../SG-TcQCmXk9.js")),
  SI: t(() => import("../../SI-EDk5vzRY.js")),
  SK: t(() => import("../../SK-BduDi-Ly.js")),
  SL: t(() => import("../../SL-Cl7-Ynke.js")),
  SM: t(() => import("../../SM-BhD0-0w0.js")),
  SN: t(() => import("../../SN-B-ngIw-4.js")),
  SO: t(() => import("../../SO-kBdl1hZg.js")),
  SR: t(() => import("../../SR-DmzThARN.js")),
  SS: t(() => import("../../SS-CO53kEST.js")),
  ST: t(() => import("../../ST-onSvD3aJ.js")),
  SV: t(() => import("../../SV-BUNfpPNz.js")),
  SX: t(() => import("../../SX-D80Rwhb0.js")),
  SY: t(() => import("../../SY-DkTpnM9R.js")),
  SZ: t(() => import("../../SZ-esjjr6hS.js")),
  TC: t(() => import("../../TC-ClFIrRe_.js")),
  TD: t(() => import("../../TD-CseAx1uC.js")),
  TG: t(() => import("../../TG-BxB5An4E.js")),
  TH: t(() => import("../../TH-CLjPs8Qi.js")),
  TJ: t(() => import("../../TJ-BB7aGl67.js")),
  TK: t(() => import("../../TK-Bmi_yP11.js")),
  TL: t(() => import("../../TL-B5kduNR4.js")),
  TM: t(() => import("../../TM-UUPlAfKB.js")),
  TN: t(() => import("../../TN-CU8bNm71.js")),
  TO: t(() => import("../../TO-BFAwfZRp.js")),
  TR: t(() => import("../../TR-CCCFcYPx.js")),
  TT: t(() => import("../../TT-Dkr4HfHB.js")),
  TV: t(() => import("../../TV-CBOYTK4v.js")),
  TW: t(() => import("../../TW-CDsBgxGJ.js")),
  TZ: t(() => import("../../TZ-ByoFMsii.js")),
  UA: t(() => import("../../UA-GU2oGLrX.js")),
  UG: t(() => import("../../UG-4yhUGFiF.js")),
  US: t(() => import("../../US-CY8FovU9.js")),
  UY: t(() => import("../../UY-CwtQ1DI4.js")),
  UZ: t(() => import("../../UZ-CMAtjCmg.js")),
  VC: t(() => import("../../VC-CnlTzbiD.js")),
  VE: t(() => import("../../VE-BHxtxoTb.js")),
  VG: t(() => import("../../VG-B8hFt4rm.js")),
  VI: t(() => import("../../VI-CTZDjv6G.js")),
  VN: t(() => import("../../VN-CzMTi1Sx.js")),
  VU: t(() => import("../../VU-C1d3pBSa.js")),
  WS: t(() => import("../../WS-DMOYcP3F.js")),
  YE: t(() => import("../../YE-fepy9yhP.js")),
  ZA: t(() => import("../../ZA-qkUVt-Wb.js")),
  ZM: t(() => import("../../ZM-u_uEGMQp.js")),
  ZW: t(() => import("../../ZW-ePh-tLXH.js"))
}, m = (r) => Object.keys(o).includes(r);
export {
  o as default,
  m as isCountryVariant
};
